// extracted by mini-css-extract-plugin
export default {"container":"BimWorkOrderActsKc2_container__E-JZh","innerBlock":"BimWorkOrderActsKc2_innerBlock__8rpR1","overlayLoader":"BimWorkOrderActsKc2_overlayLoader__rdcYw"};